export default "<nb-menu [items]=\"menu\"></nb-menu>\r\n";